import { useState, useCallback } from 'react';

const usePersistedColumnOrder = (tableKey, initialColumns) => {
  const [columns, setColumns] = useState(() => {
    const savedOrder = localStorage.getItem(`columnsOrder_${tableKey}`);
    if (savedOrder) {
      const savedFieldsOrder = JSON.parse(savedOrder);
      const reorderedColumns = savedFieldsOrder.map((field) =>
        initialColumns.find((col) => col.field === field)
      );
      return reorderedColumns.filter(Boolean);
    }
    return initialColumns;
  });

  const updateColumnOrder = useCallback(
    (newOrder) => {
      setColumns(newOrder);
      const fieldOrder = newOrder.map((col) => col.field);
      localStorage.setItem(
        `columnsOrder_${tableKey}`,
        JSON.stringify(fieldOrder)
      );
    },
    [tableKey]
  );

  return [columns, updateColumnOrder];
};

export default usePersistedColumnOrder;
